import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import I18n from "i18n-js";
import { formatDateTime } from "../../common/utils/dateUtils";
import { array, string, instanceOf } from "prop-types";

const triggers = ["focus", "hover", "click"];

TrackdechetsErrorWithTooltip.propTypes = {
  tooltipTitle: string.isRequired,
  badgeLabel: string.isRequired,
  lastUpdatedAt: instanceOf(Date),
  errors: array.isRequired,
};

export function TrackdechetsErrorWithTooltip({
  tooltipTitle,
  badgeLabel,
  lastUpdatedAt,
  errors,
}) {
  return (
    <OverlayTrigger
      trigger={triggers}
      placement="auto"
      delay={{ show: 10, hide: 150 }}
      overlay={
        <Popover style={{ position: "fixed" }}>
          <Popover.Header as="h5">{tooltipTitle}</Popover.Header>
          <Popover.Body>
            {"The following errors were sent by Trackdéchets:"}
            <br />
            <ul className="mt-1 mb-0 pt-0">
              {errors.map((e, i) => (
                <li key={i}>
                  <b>{e.code}</b>: {e.error}
                </li>
              ))}
            </ul>
            <br />
            <small>
              {I18n.t(
                "trackdechets.sync_statuses_table.cell.badges.invalid.lastUpdatedAt",
                {
                  date: formatDateTime(lastUpdatedAt),
                },
              )}{" "}
            </small>
          </Popover.Body>
        </Popover>
      }
    >
      <span tabIndex={1} className={"badge bg-danger"}>
        {badgeLabel}
      </span>
    </OverlayTrigger>
  );
}
